import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// Importa los componentes (sin cambios aquí)
import { dashboard_data } from '../../../utils/services';
import { useNavigate } from 'react-router-dom';
import Current_activity from './Current_activity';
import Current_activity_map from './Current_activity_map';

// Estilos personalizados si son necesarios


const Dashboard = ({ usr_id, usr_type,self_cards, member_trello_id, onPendingClassificationChange }) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  

  useEffect(() => { 
    console.log("Dashboard useEffect", token, usr_type);
    if(usr_type == 0){
      if (token) {
        fetchLoadDashboardData();
      }
    }else{
      navigate("/opportunities");
    }
  }, [token]);

 async function fetchLoadDashboardData() {
 
      const dashboardfetchData = await dashboard_data(token);
      if (dashboardfetchData==="INVALID"){
        localStorage.removeItem("token");
        navigate("/");
      }else{
           let pendingExpensesAmount = 0;
           dashboardfetchData['expenses_data'].forEach((item) => {
            if (item.usr_id_payer==usr_id) pendingExpensesAmount = item.total_amount;
           });
          if (typeof onPendingClassificationChange === 'function') {
            onPendingClassificationChange(pendingExpensesAmount);
          }
     }
  }

  return (
    <Container fluid className="p-4">
      <Row className="g-4 mb-4 align-items-stretch">
        <Col xs={12}>
          <Current_activity_map token={token} />
        </Col>
      </Row>
      <Row className="g-4 mb-4 align-items-stretch">
        
      
      </Row>
    </Container>
  );
};

export default Dashboard;